var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('prismic-rich-text',_vm._b({ref:"text",staticClass:"rich-text"},'prismic-rich-text',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }